import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { AppSettings, UpdateSettingsInput } from '@fleet/shared';
import { api } from '../../lib/apiClient';

export function useSettings() {
  return useQuery({
    queryKey: ['settings'],
    queryFn: () => api.get<{ settings: AppSettings }>('/settings').then((r) => r.settings),
  });
}

export function useUpdateSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateSettingsInput) =>
      api.put<{ settings: AppSettings }>('/settings', input).then((r) => r.settings),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['settings'] });
      qc.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}

/** Eén heen-en-weer langs de AI Gateway met het ingestelde model, zodat een
 *  beheerder ziet of de omgeving werkt zonder een factuur te hoeven uploaden. */
export function testAi(): Promise<{ ok: true; model: string }> {
  return api.post<{ ok: true; model: string }>('/settings/test-ai');
}
